import { HttpInterceptorFn, HttpContextToken } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoadingService } from "../service/loading.service";

export const NO_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  const isAsset = req.url.includes("/assets/");
  const skip = isAsset || req.context.get(NO_GLOBAL_LOADING);

  if (!skip) loading.start();

  return next(req).pipe(
    finalize(() => {
      if (!skip) loading.stop();
    })
  );
};
